import type { CSSProperties } from 'react';

export const TOKENS = {
  teal: '#15A08C',
  tealHover: '#0F8474',
  tealTint: '#E1F5EE',
  tealInk: '#0B7377',
  ink: '#000000',
  dark: '#1A2332',
  slateHead: '#12262B',
  bg: '#F4F6F8',
  card: '#FFFFFF',
  line: '#E7EAF0',
  lineStrong: '#D1D5DB',
  amber: '#B7791F',
  amberTint: '#FDF3E2',
  amberLine: '#F1DDB8',
  amberText: '#7A4A00',
  neutralPill: '#EEF1F4',
} as const;

export const toolbarStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginTop: 18,
  position: 'relative',
  flexWrap: 'wrap',
  background: '#fff',
  border: '1px solid ' + TOKENS.line,
  borderRadius: 12,
  padding: '10px 14px',
};

export function tabStyle(active: boolean): CSSProperties {
  return {
    padding: '7px 18px',
    background: active ? 'white' : 'transparent',
    border: 'none',
    borderRadius: 8,
    color: active ? TOKENS.ink : TOKENS.dark,
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: active ? 700 : 600,
    cursor: 'pointer',
    boxShadow: active ? '0 1px 2px rgba(16, 30, 40, 0.08)' : 'none',
  };
}